<template>
    <div class="welfare-page">
        <om-loading
            v-if="isWelfareLoading"
            :visable="isWelfareLoading"
            type="whole"
            theme="blue"
        />
        <mui-errorloading v-else-if="isWelfareError"/>
        <welfare-content v-else ref="welfareContent"/>
    </div>
</template>

<script>
import WelfareContent from './components/WelfareContent';
import {mapMutations, mapActions} from 'vuex';
import StatisticConst from '../../constant/StatisticConst';
export default {
    data() {
        return {
            isWelfareError: false,
            isWelfareLoading: true,
            wcRef: 0,
            taskListTop: 0
        };
    },
    components: {
        WelfareContent
    },
    computed: {
    },
    watch: {
        taskListTop(n, o) {
            if (this.$route.query.type === 'task') {
                this.scrollToTaskList();
            }
        }
    },
    created() {
        StatisticConst.welfareShow();
        this.getMainData();
        this.getWelfareData();
        this.initBackEvent();
    },
    mounted() {
        this.$nextTick(() => {
            this.wcRef = this.$refs.welfareContent;
        });
    },
    updated() {
        this.getUrlParams();
        this.taskListTop = this.wcRef && this.wcRef.conRef && this.wcRef.conRef.offsetTop;
    },
    methods: {
        ...mapMutations([
            'setMyCoin'
        ]),
        ...mapMutations('kingRoad', [
            'setMedalNum'
        ]),
        ...mapActions([
            'getUrlParams',
            'getMainData'
        ]),
        ...mapActions('welfare', [
            'getTaskLotteryInfo'
        ]),
        // 获取商城数据
        getWelfareData() {
            this.getTaskLotteryInfo().then(resData => {
                this.isWelfareError = false;
                this.isWelfareLoading = false;
                // 同步金币及徽章数量
                if (resData) {
                    // 金币数量
                    this.setMyCoin(resData.myCoin);
                    // 徽章数量
                    this.setMedalNum(resData.medalNum);
                }
            }).catch(() => {
                this.isWelfareError = true;
                this.isWelfareLoading = false;
            });
        },
        // 自动滚动到指定任务位置
        scrollToTaskList() {
            if (this.$el && !this.isWelfareError && !this.isWelfareLoading) {
                this.$el.scrollTop = this.taskListTop;
            }
        },
        // 初始化返回监听
        initBackEvent() {
            const that = this;
            // 监听客户端返回webview
            window.noticeBack = () => {
                that.getWelfareData();
            };
        }
    }
};
</script>
<style src="./Welfare.scss" lang="scss"></style>
